import { useCallback, useContext } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import {
    ResponseContext,
    SwiggyContextHeader,
    TableContext,
    ToastType,
    loginHelper,
    PinGenerationStatus,
    QrCodeActions,
} from "@swiggy-private/portal-dineout-context";
import { ERROR_MESSAGES } from "../constants/messages";
import { getBridgeSdk } from "../utils";
import { isUserLoggedIn } from "../utils/auth";

export const useActions = () => {
    const { state, dispatch } = useContext(ResponseContext);
    const { swiggyHeaders } = useContext(SwiggyContextHeader);
    const { verifyPinFlow, setVerifyPinFlow } = useContext(TableContext);
    const isLoggedIn = isUserLoggedIn(swiggyHeaders);

    const handleLogin = useCallback(() => {
        if (!isLoggedIn) {
            loginHelper({
                sdk: getBridgeSdk(),
                forwardPath: window.location.pathname + window.location.search,
            });
            return false;
        }
        return true;
    }, [isLoggedIn]);

    const handlePin = useCallback(() => {
        if (isEmpty(state?.pin?.data?.status) || state?.pin?.error) {
            dispatch({
                type: QrCodeActions.SHOW_TOAST,
                payload: {
                    type: ToastType.ERROR,
                    message: ERROR_MESSAGES.PIN_NOT_GENERATED,
                },
            });
            return false;
        }

        if (
            state.pin.data.status === PinGenerationStatus.PIN_GENERATED_BY_OTHER_USER &&
            state.pin.data.userStatus !== PinGenerationStatus.USER_VERIFIED
        ) {
            setVerifyPinFlow?.(true);
            return false;
        }

        return true;
    }, [dispatch, state.pin, setVerifyPinFlow]);

    const isPinVerified = state.pin?.data?.userStatus === PinGenerationStatus.USER_VERIFIED;

    return {
        handleLogin,
        handlePin,
        isLoggedIn,
        isPinVerified,
        verifyPinFlow,
        setVerifyPinFlow,
    };
};
